import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { breakpoints } from '../../utils/helpers';
import ProductItem from '../../components/Product/ProductItem';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

const HomeFeatured = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const scale = () => { setIsMobile(window.innerWidth < breakpoints.sm); }
    window.addEventListener('resize', scale);
    window.dispatchEvent(new Event('resize'));

    return () => {
      window.removeEventListener('resize', scale)
    }
  }, [])

  const featuredQuery = useStaticQuery(graphql`
    query {
      shopifyCollection(handle: {eq: "featured"}) {
        id
        products {
          id
          createdAt
          priceRangeV2 {
            maxVariantPrice {
              amount
            }
            minVariantPrice {
              amount
            }
          }
          vendor
          title
          handle
          featuredImage {
            altText
            src
          }
          variants {
            title
            price
            availableForSale
            compareAtPrice
            legacyResourceId
            storefrontId
            selectedOptions {
              name
            }
          }
          shopifyId
          metafields {
            key
            namespace
            value
          }
        }
      }
    }
  `)

  const featured = featuredQuery.shopifyCollection?.products || [];
  if(!featured?.length) {
    return null
  }

  return (
    <section className="Home__featured">
      <div className="Container">
        <h2 className="Title Title--lined">
          <span>Featured Products</span>
        </h2>

        {isMobile ? (
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={30}
            slidesPerView={1.5}
            loop={true}
            centeredSlides={true}
            navigation={true}
            pagination={{clickable: true}}
            className="Home__featured__products Home__featured__products--mobile"
          >
            {featured.map((item, index) => (
              <SwiperSlide>
                <ProductItem data={item} key={index} />
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="Home__featured__products">
            {featured.map((item, index) => (
              <ProductItem data={item} key={index} />
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default HomeFeatured